import { render, staticRenderFns } from "./setting-nav.vue?vue&type=template&id=32dd83c8&scoped=true&"
import script from "./setting-nav.vue?vue&type=script&lang=ts&"
export * from "./setting-nav.vue?vue&type=script&lang=ts&"
import style0 from "./setting-nav.vue?vue&type=style&index=0&id=32dd83c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd83c8",
  null
  
)

export default component.exports